export default [
  {
    title: 'unit',
    icon: 'mdi-map-marker',
    home: 'unit.list',
    subMenu: [
      {
        title: 'unit-list',
        goto: 'unit.list',
        children: ['unit.list', 'unit.create', 'unit.edit']
      },
      {
        title: 'time-title',
        goto: 'time-title.list',
        children: ['time-title.list']
      },
      {
        title: 'region',
        goto: 'region.list',
        children: ['region.list', 'region.create', 'region.edit']
      },
      {
        title: 'differential',
        goto: 'differential.list',
        children: ['differential.list', 'differential.create', 'differential.edit']
      },
      {
        title: 'service',
        goto: 'service.list',
        children: ['service.list', 'service.create', 'service.edit']
      }
    ]
  },
  {
    title: 'attendance',
    icon: 'mdi-cellphone',
    home: 'attendance.list',
    subMenu: [
      {
        title: 'attendance-list',
        goto: 'attendance.list',
        children: ['attendance.list', 'attendance.show']
      },
      {
        title: 'email',
        goto: 'email.list',
        children: ['email.list', 'email.create', 'email.edit']
      }
    ]
  },
  {
    title: 'procedure',
    icon: 'mdi-folder',
    abstract: true,
    home: 'procedure.list',
    children: ['procedure.list', 'procedure.show'],
    goto: 'procedure.list'
  },
  {
    title: 'news',
    icon: 'mdi-earth',
    abstract: true,
    home: 'news.list',
    children: ['news.list', 'news.create', 'news.edit'],
    goto: 'news.list'
  },
  {
    title: 'custom-page',
    icon: 'mdi-lead-pencil',
    home: 'page.about',
    subMenu: [
      {
        title: 'page.home-app',
        goto: 'page.home-app',
        children: ['page.home-app']
      },
      {
        title: 'page-video-home',
        goto: 'page.video-home',
        children: ['page.video-home']
      },
      {
        title: 'page-about',
        goto: 'page.about',
        children: ['page.about']
      },
      {
        title: 'page-privacy',
        goto: 'page.privacy',
        children: ['page.privacy']
      },
      {
        title: 'page-cid',
        goto: 'page.cid',
        children: ['page.cid']
      }
    ]
  },
  {
    title: 'users-and-groups',
    icon: 'mdi-account-circle',
    home: 'admin.list',
    subMenu: [
      {
        title: 'admin',
        goto: 'admin.list',
        children: ['admin.list', 'admin.create', 'admin.edit'],
      },
      {
        title: 'group',
        goto: 'group.list',
        children: ['group.list', 'group.create', 'group.edit'],
      }
    ]
  },
  {
    title: 'vaccine',
    icon: 'mdi-calendar',
    home: 'vaccine.list',
    subMenu: [
      {
        title: 'target',
        goto: 'target.list',
        children: ['target.list'],
      },
      {
        title: 'target-category',
        goto: 'target.category',
        children: ['target.category'],
      },
      {
        title: 'vaccine-vaccine',
        goto: 'vaccine.list',
        children: ['vaccine.list', 'vaccine.create', 'vaccine.edit'],
      }
    ]
  },
  {
    title: 'card',
    icon: 'mdi-needle',
    abstract: true,
    home: 'card.list',
    children: ['card.list', 'card.create', 'card.edit'],
    goto: 'card.list'
  },
  {
    title: 'insurance',
    icon: 'mdi-hospital',
    abstract: true,
    home: 'insurance.list',
    subMenu: [
      {
        title: 'insurance',
        goto: 'insurance.list',
        children: ['insurance.list', 'insurance.create', 'insurance.edit'],
      },
      {
        title: 'insurance-states',
        goto: 'insurance.state',
        children: ['insurance.state.list', 'insurance.state.create', 'insurance.state.edit', 'insurance.city.create', 'insurance.city.edit'],
      }
    ]
  },
  {
    title: 'campaign',
    icon: 'mdi-star-circle',
    abstract: true,
    home: 'campaign.list',
    children: ['campaign.list', 'campaign.create', 'campaign.edit'],
    goto: 'campaign.list'
  },
  {
    title: 'client',
    icon: 'mdi-clipboard-account',
    abstract: true,
    home: 'client.report',
    children: ['client.report'],
    goto: 'client.report'
  },
  {
    title: 'notification',
    icon: 'mdi-message-alert',
    abstract: true,
    home: 'notification.list',
    children: ['notification.create', 'notification.list', 'notification.edit'],
    goto: 'notification.list'
  },
  {
    title: 'pop-up',
    icon: 'mdi-file-image',
    abstract: true,
    home: 'pop-up.list',
    children: ['pop-up.create', 'pop-up.list', 'pop-up.edit'],
    goto: 'pop-up.list'
  },
  {
    title: 'app-version.list',
    icon: 'mdi-checkbox-marked-circle',
    abstract: true,
    home: 'app-version.list',
    children: ['app-version.list'],
    goto: 'app-version.list'
  },
  {
    title: 'apiaccesslog',
    icon: 'mdi-yeast',
    abstract: true,
    home: 'apiaccesslog.list',
    children: ['apiaccesslog.create', 'apiaccesslog.list', 'apiaccesslog.edit'],
    goto: 'apiaccesslog.list'
  },
  {
    title: 'faq',
    icon: 'mdi-comment-question',
    abstract: true,
    subMenu: [
      {
        title: 'faq.list',
        goto: 'faq.list',
        children: ['faq.categories.list', 'faq.log-list', 'faq.log-detail']
      },
      {
        title: 'faq-categories',
        goto: 'categories.list'
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./client/app/common/layout/sidenav/sidenav.menu.js